<template>
    <div v-loading="loading" class="user-portfolio-achievements">
        <div class="user-portfolio-achievements__head">
            <div class="user-portfolio-achievements__head-title">
                <span>Достижения</span>
                <strong v-if="list.length" @click="popupOpened = true">
                    {{ list.length }}
                </strong>
            </div>
            <div
                v-if="list.length > limit"
                class="user-portfolio-achievements__head-see-all"
                @click="popupOpened = true"
            >
                Смотреть все
            </div>
        </div>
        <div v-if="list.length" class="user-portfolio-achievements__list">
            <a
                v-for="(item, index) in listLimited"
                :key="index"
                class="user-portfolio-achievements__list-item"
                :href="achievementLink(item.testName , item.uid)"
                target="_blank"
            >
                <div class="user-portfolio-achievements__list-item-image">
                    <img :src="getPreviewImage(item.reportType)" :alt="item.testName" />
                </div>
                <div class="user-portfolio-achievements__list-item-name">{{ item.testName }}</div>
            </a>
        </div>
        <div v-else class="user-portfolio-achievements__empty">
            Нет достижений
        </div>


        <Modal :opened="popupOpened" @close="popupOpened = false">
            <div v-loading="loading" class="user-portfolio-achievements user-portfolio-achievements--modal">
                <div class="user-portfolio-achievements__head">
                    <div class="user-portfolio-achievements__head-title">
                        <span>Достижения</span>
                        <strong v-if="list.length">
                            {{ list.length }}
                        </strong>
                    </div>
                </div>
                <div class="user-portfolio-achievements__list">
                    <div
                        v-for="(group, index) in listGrouped"
                        :key="index"
                        class="user-portfolio-achievements__list-wrapper"
                    >
                        <div class="user-portfolio-achievements__list-wrapper-title">
                            {{ group.name }}
                        </div>
                        <a
                            v-for="(item, itemIndex) in group.reports"
                            :key="itemIndex"
                            class="user-portfolio-achievements__list-item"
                            :href="achievementLink(item.testName , item.uid)"
                            target="_blank"
                        >
                            <div class="user-portfolio-achievements__list-item-image">
                                <img :src="getPreviewImage(item.reportType)" :alt="item.testName" />
                            </div>
                            <div class="user-portfolio-achievements__list-content">
                                <div class="user-portfolio-achievements__list-item-name">{{ item.testName }}</div>
                                <div class="user-portfolio-achievements__list-item-date">{{ formatDate(item.createdAt) }}</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from "vuex";
import Modal from "@/components/UI/Modal.vue";
import moment from "moment";

export default {
    components: {
        Modal,
    },
    data: () => ({
        loading: false,
        limit: 3,
        popupOpened: false,
        achievements: [],
        reportGroups: [],
    }),

    async created() {
        this.loading = true;

        const data = await Promise.all([
            this.loadReportGroups(true),
            this.initAchievements(this.getUser.userId),
        ]);

        if (data[0]) {
            this.reportGroups =  [].concat(
                ...(data[0].filter(v => v.showInAchievements === true).map(v => v.reportTypes.map(vt => vt.reportType)))
            ).filter((v, index, arr) => {
                return arr.indexOf(v) === index;
            });
        }

        this.loading = false;
    },

    watch: {
        async 'getUser.userId'(userId) {
            this.loading = true;

            await this.initAchievements(userId);

            this.loading = false;
        },
        list() {
            this.setUserAchievements(this.list);
        },
    },

    computed: {
        ...mapGetters([
            'getUser',
        ]),
        ...mapGetters('newUsers', [
            'getUser',
        ]),

        list() {
            return this.getList(this.listGrouped);
        },

        listLimited() {
            return this.list.slice(0, this.limit);
        },

        listGrouped() {
            return this.getListGrouped(this.achievements);
        },
    },

    methods: {
        ...mapActions([
            'loadAchievementsByUserId',
            'loadReportTypes',
            'loadReportGroups',
        ]),
        ...mapMutations('newUsers', [
            'setUserAchievements',
        ]),

        async initAchievements(userId) {
            this.achievements = await this.loadAchievementsByUserId(userId);
        },

        achievementLink(name, uid) {
            return `https://reporting.${window.rsvDomain}/api/v1/report/${uid}`;
        },

        formatDate(date) {
            return moment(date).format('DD.MM.YYYY');
        },

        getList(listGrouped) {
            const list = [];

            listGrouped.forEach(group => {
                group.reports.forEach(item => {
                    list.push(item);
                });
            });

            return list.sort((a, b) => a.createdAt === b.createdAt ? 0 : a.createdAt > b.createdAt ? -1 : 1);
        },
        getListGrouped(achievements) {
            const list = [];

            achievements.forEach(group => {
                const groupFiltered = { ...group, reports: [] };

                group.reports.forEach(item => {
                    if (this.reportGroups.indexOf(item.reportType) > -1) {
                        groupFiltered.reports.push(item);
                    }
                });

                if (groupFiltered.reports.length) {
                    list.push(groupFiltered);
                }
            });

            return list.sort((a, b) => a.createdAt === b.createdAt ? 0 : a.createdAt > b.createdAt ? -1 : 1);
        },

        getPreviewImage(type) {
            return require(`@/assets/images/account-reporting/${type}.png`);
        },
    },
};

</script>

<style scoped lang="scss">
@import "~@/styles/rem";
@import '~@/styles/variables';

.user-portfolio-achievements {
    display: flex;
    flex-direction: column;
    gap: mrem(40);

    @include on-desktop {
        gap: rem(40);
    }

    &__head {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        gap: mrem(16);

        @include on-desktop {
            gap: rem(16);
            align-items: center;
            flex-direction: row;
        }

        &-title {
            font-weight: 700;
            font-size: mrem(18);
            line-height: mrem(24);

            @include on-desktop {
                font-size: rem(18);
                line-height: rem(24);
            }

            strong {
                color: $color-main-blue;
                font-weight: 500;
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        &-see-all {
            color: $color-main-blue;
            font-weight: 400;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }
    }
    &__list {
        display: flex;
        flex-direction: column;
        gap: mrem(30);

        @include on-desktop {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: rem(30);
        }

        &-item {
            display: flex;
            flex-direction: column;
            text-align: center;
            font-weight: 400;
            gap: mrem(16);
            align-items: center;

            @include on-desktop {
                gap: rem(16);
            }

            &-image {
                width: mrem(178);
                height: mrem(100);
                margin: 0 mrem(15) mrem(10) mrem(15);
                border-radius: mrem(16);
                box-shadow: 0 0 mrem(16) 0 rgba(70, 99, 171, 0.20);
                position: relative;

                @include on-desktop {
                    width: rem(178);
                    height: rem(100);
                    margin: 0 rem(15) rem(10) rem(15);
                    border-radius: rem(16);
                    box-shadow: 0 0 rem(16) 0 rgba(70, 99, 171, 0.20);
                }

                img {
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: contain;
                }

                &::after {
                    display: block;
                    content: '';
                    position: absolute;
                    background: url("~@/assets/images/portfolio/medal.svg") 50% / contain no-repeat;
                    width: mrem(55);
                    height: mrem(55);
                    bottom: mrem(-22);
                    right: mrem(-22);

                    @include on-desktop {
                        width: rem(55);
                        height: rem(55);
                        bottom: rem(-22);
                        right: rem(-22);
                    }
                }
            }
            &-name {
                flex: 0 1 auto;
            }
        }
    }

    &__empty {
        color: $color-main-primary;
        font-weight: 500;
    }

    &--modal {
        gap: mrem(24);
        font-family: $font-montserrat;
        font-style: normal;
        font-weight: 400;
        color: #2A2626;
        font-size: mrem(16);
        line-height: mrem(22);

        @include on-desktop {
            gap: rem(24);
            max-width: rem(650);
            font-size: rem(16);
            line-height: rem(22);
        }

        a:hover {
            text-decoration: none;
        }

        .user-portfolio-achievements__head {
            &-title {
                font-size: mrem(24);

                @include on-desktop {
                    font-size: rem(24);
                }

                strong {
                    font-weight: 400;
                    cursor: initial;

                    &:hover {
                        text-decoration: none;
                    }
                }
            }
        }
        .user-portfolio-achievements__list {
            display: flex;
            flex-direction: column;
            gap: mrem(40);

            @include on-desktop {
                gap: rem(40);
                padding-bottom: rem(20);
            }

            &-wrapper {
                display: flex;
                flex-direction: column;
                gap: mrem(40);

                @include on-desktop {
                    gap: rem(40);
                }

                &-title {
                  font-weight: 600;
                }
            }

            &-item {
                display: grid;
                text-align: left;
                grid-template-columns: mrem(100) auto;
                gap: mrem(44);
                margin: 0 mrem(-20);

                @include on-desktop {
                    display: grid;
                    grid-template-columns: rem(173) auto;
                    gap: rem(44);
                    margin: 0;
                }

                &-image {
                    width: mrem(100);
                    height: mrem(56);

                    @include on-desktop {
                        width: rem(178);
                        height: rem(100);
                    }
                }
                &-name {
                    font-weight: 500;
                    margin-bottom: mrem(16);
                    margin-top: mrem(10);

                    @include on-desktop {
                        margin-bottom: rem(16);
                        margin-top: rem(10);
                    }
                }
                &-date {
                    color: $color-secondary-grey;
                    font-weight: 500;
                    font-size: mrem(14);
                    line-height: mrem(22);

                    @include on-desktop {
                        font-size: rem(14);
                        line-height: rem(22);
                    }
                }
            }
        }
    }
}
</style>
